module.exports = __webpack_public_path__ + "static/media/cover.72451244.png";